import type { Ref } from 'vue';
import {
  ref,

} from 'vue';

import type { IRolesNamespaces } from '@modules/roles-and-permissions/types';

export interface RolesAndPermissionsComposable {
  activeTab: Ref<string>;
  namespace: Ref<IRolesNamespaces | undefined>;
  createdRoleId: Ref<number | undefined>;
  handleNamespaceChange(val: IRolesNamespaces): void;
  handleCreateRoleSuccess(roleId: number): void;
}

export default function useRolesAndPermissions(): RolesAndPermissionsComposable {
  const activeTab = ref('0');
  const namespace = ref<IRolesNamespaces>();
  const createdRoleId = ref<number>();

  function handleNamespaceChange(val: IRolesNamespaces): void {
    namespace.value = val;
    createdRoleId.value = undefined;
  }

  function handleCreateRoleSuccess(roleId: number): void {
    createdRoleId.value = roleId;
    activeTab.value = '1';
  }

  return {
    activeTab,
    namespace,
    createdRoleId,
    handleNamespaceChange,
    handleCreateRoleSuccess,
  };
}
